import React from 'react';
import Carousel from 'react-material-ui-carousel'
import {Paper, makeStyles, Grid} from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery';

function Item({parceiro})
{ 
  const classes = useStyles();
  return (
    <Paper  className={classes.root}>
      <Grid container
          className={classes.conteudo}
          xs={12}
          spacing={5}
          >
        { parceiro?.map((atual, index) => (
          <Grid item xs={3}>
            <a href = {atual.website} className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
            >
              <img key={atual} 
                src={atual.logo || atual.image_url} 
                alt="Patrocinador"
                className={classes.img}
              />
            </a>
          </Grid>
        ))}
      </Grid>
    </Paper>
  )
}

export default function CarouselParceirosF({partners})
{
  // All hooks must be called before any early returns
  const isSmallHeight = useMediaQuery('(max-height:665px)');
  const isVerySmallHeight = useMediaQuery('(max-height:520px)');
  const isTinyHeight = useMediaQuery('(max-height:380px)');

  // Ensure partners is an array and not empty
  const validPartners = Array.isArray(partners) ? partners : [];
  
  if (validPartners.length === 0) {
    return null; // Don't render if no partners
  }

  let parceiro_por_pagina = 4;
  if(isTinyHeight) parceiro_por_pagina = 1;
  else if(isVerySmallHeight) parceiro_por_pagina = 2;
  else if(isSmallHeight) parceiro_por_pagina = 3;

  const pages = Array.from(Array(Math.ceil(validPartners.length/parceiro_por_pagina)).keys())
  const parceiros = pages.map(page => validPartners.slice(page*parceiro_por_pagina, page*parceiro_por_pagina+parceiro_por_pagina))

  return (
    <Carousel>
      {
        parceiros?.map( (parceiro, i) => <Item key={i} parceiro={parceiro} /> )
      }
    </Carousel>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  conteudo: {
    width: "100%",
    height: "100%",
    maxWidth: "1366px",
    alignItems: "center",
    flexDirection: "column",
    display: "flex",
  },
  img: {
    maxWidth: "320px",
    maxHeight: "260px",
    objectFit: "contain",
  },
  link: {
    height:"100%",
    width:"100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
}));